import clsx from 'clsx';
import React from 'react';

function ErrorMessage({ variant = 'error', children }) {
  return (
    <div
      className={clsx(`my-2`, {
        'text-red-500': variant === 'error',
        'text-gray-800': variant === 'notice',
      })}
    >
      {children}
    </div>
  );
}

export default ErrorMessage;
